export default __webpack_public_path__ + "static/media/IMG_3065_3_11zon.6803cd14.jpg";